'use client';

import { ReactElement } from 'react';
import { css } from '@bts-web/utils-style-engine';

const buttonTitleStyles = css({
  fontSize: 'label.medium_medium',
  fontWeight: 'label.medium_medium',
  letterSpacing: 'label.medium_medium',
  lineHeight: 'label.medium_medium',
  textAlign: 'start',
});

export const iconContainerStyles = css({
  display: 'flex',
  width: '40px',
  height: '40px',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
});

const buttonStyles = css({
  display: 'flex',
  gap: 'small',
  alignItems: 'center',
  cursor: 'pointer',
  padding: 'medium',
  borderBottomWidth: '1px',
  borderBottomColor: 'neutrals.divider',
  color: 'neutrals.text_primary',
  '&:active': {
    background: 'rgba(1,1,1,0.1)',
  },
  '& [data-element="icon"]': {
    backgroundColor: 'brand.fill_primary',
    color: 'brand.text_primary_inverted',
  },
  '&:disabled': {
    pointerEvents: 'none',
    backgroundColor: 'neutrals.fill_disabled',
    color: 'neutrals.text_disabled',
    '& [data-element="icon"]': {
      backgroundColor: 'neutrals.fill_disabled',
      color: 'brand.on_fill_primary',
    },
  },
});

const buttonContentStyles = css({
  display: 'flex',
  gap: '2px',
  flexDirection: 'column',
  alignItems: 'start',
  flex: 1,
});

const buttonSubTitleStyles = css({
  color: 'neutrals.text_secondary',
  fontSize: 'caption.small',
  fontWeight: 'caption.small',
  lineHeight: 'caption.small',
  letterSpacing: 'caption.small',
  textAlign: 'start',
});

export interface TradeOptionButtonProps {
  title: string;
  subtitle?: string;
  icon: ReactElement;
  tag?: ReactElement;
  dataTestId?: string;
  disabled?: boolean;
  onClick: () => void;
}

const TradeOptionButton = ({
  title,
  subtitle,
  icon,
  tag,
  dataTestId,
  onClick,
  ...rest
}: TradeOptionButtonProps) => {
  return (
    <button
      type="button"
      className={buttonStyles}
      data-testid={dataTestId}
      onClick={onClick}
      {...rest}
    >
      <div className={iconContainerStyles} data-element="icon">
        {icon}
      </div>

      <div className={buttonContentStyles}>
        <span className={buttonTitleStyles}>{title}</span>

        {subtitle && <span className={buttonSubTitleStyles}>{subtitle}</span>}
      </div>

      {tag ? tag : null}
    </button>
  );
};

export { TradeOptionButton };
